/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CommentNotificationActionData } from './CommentNotificationActionData';
import {
    CommentNotificationActionDataFromJSON,
    CommentNotificationActionDataFromJSONTyped,
    CommentNotificationActionDataToJSON,
} from './CommentNotificationActionData';

/**
 * 
 * @export
 * @interface CommentNotificationAction
 */
export interface CommentNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof CommentNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof CommentNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof CommentNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {CommentNotificationActionData}
     * @memberof CommentNotificationAction
     */
    data: CommentNotificationActionData;
}

/**
 * Check if a given object implements the CommentNotificationAction interface.
 */
export function instanceOfCommentNotificationAction(value: object): value is CommentNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function CommentNotificationActionFromJSON(json: any): CommentNotificationAction {
    return CommentNotificationActionFromJSONTyped(json, false);
}

export function CommentNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommentNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': CommentNotificationActionDataFromJSON(json['data']),
    };
}

export function CommentNotificationActionToJSON(value?: CommentNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': CommentNotificationActionDataToJSON(value.data),
    };
}

